import React from 'react';
import moment from 'moment';

const C = {
  ink: '#333333',
  sub: '#666666',
  muted: '#8B9097',
  line: '#ECECEE',
  primary: '#FF6467',
  wash: '#FFEAEA',
  surface: '#FFFFFF',
  danger: '#E05C35',
};

const SectionDate = ({
  event,
  setEvent,
  dateAlert,
  eventDateError,
  isDateChangeProhibitionDisplay,
  isEventEndDatetimeTouched,
  handleEventDateInput,
}) => {
  const maxMoment = moment().add(6, 'months');
  const maxDateTimeLocal = maxMoment.format('YYYY-MM-DDTHH:mm');

  // OS標準の datetime-local ピッカーに統一（旧jQuery datetimepickerを廃止）
  const datetimeFormType = 'datetime-local';
  const datetimeFormat = 'YYYY-MM-DDTHH:mm';

  const rowStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    padding: '13px 0',
    margin: 0,
  };
  const labelStyle = { fontSize: 14, color: C.ink, margin: 0, flex: 'none' };
  const inputStyle = {
    flex: 1,
    minWidth: 0,
    textAlign: 'right',
    border: 'none',
    outline: 'none',
    background: 'transparent',
    fontSize: 15,
    fontWeight: 700,
    color: C.ink,
    padding: 0,
  };
  const hasError = !!eventDateError;

  return (
    <section id="event_date">
      <style>{`.tg-dt-input::placeholder{color:#BCC1C6;opacity:1;font-weight:400;}`}</style>
      <div className="container col-md-8 col-lg-6" style={{ paddingTop: 8 }}>
        <div
          style={{
            background: C.surface,
            border: `1px solid ${hasError ? C.danger : C.line}`,
            borderRadius: 16,
            padding: '14px 16px',
            boxShadow: '0 1px 2px rgba(30,30,40,.03), 0 10px 26px -16px rgba(30,30,40,.14)',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
            <span style={{ fontSize: 12, fontWeight: 800, color: C.sub, letterSpacing: '.02em' }}>イベント日時</span>
            <span style={{ fontSize: 10, fontWeight: 800, color: C.primary, background: C.wash, borderRadius: 5, padding: '1px 6px' }}>
              必須
            </span>
          </div>
          {dateAlert && <p style={{ color: C.danger, fontSize: 12, margin: '6px 0 0' }}>{dateAlert}</p>}
          {isDateChangeProhibitionDisplay && (
            <p style={{ color: C.danger, fontSize: 12, margin: '6px 0 0' }}>日付を変更することはできません。</p>
          )}
          {eventDateError && <p style={{ color: C.danger, fontSize: 12, margin: '6px 0 0' }}>{eventDateError}</p>}

          <label htmlFor="event-start-datetime-input-form" style={{ ...rowStyle, borderBottom: `1px solid ${C.line}` }}>
            <p style={labelStyle}>開始時刻</p>
            <input
              type={datetimeFormType}
              className="form-style-reset tg-dt-input"
              id="event-start-datetime-input-form"
              value={event.event_date ? moment(event.event_date).format(datetimeFormat) : ''}
              onChange={(e) => {
                handleEventDateInput(e);
              }}
              onBlur={(e) => {
                handleEventDateInput(e);
              }}
              placeholder="タップして設定"
              autoComplete="off"
              max={maxDateTimeLocal}
              style={inputStyle}
            />
          </label>
          <label htmlFor="event-end-datetime-input-form" style={rowStyle}>
            <p style={labelStyle}>終了時刻</p>
            <input
              type={datetimeFormType}
              className="form-style-reset tg-dt-input"
              id="event-end-datetime-input-form"
              value={event.event_end_datetime ? moment(event.event_end_datetime).format(datetimeFormat) : ''}
              onChange={(e) => {
                isEventEndDatetimeTouched.current = true;
                setEvent((prev) => ({ ...prev, event_end_datetime: e.target.value }));
              }}
              onBlur={(e) => {
                isEventEndDatetimeTouched.current = true;
                setEvent((prev) => ({ ...prev, event_end_datetime: e.target.value }));
              }}
              placeholder="タップして設定"
              autoComplete="off"
              max={maxDateTimeLocal}
              style={inputStyle}
            />
          </label>
        </div>
      </div>
    </section>
  );
};

export default SectionDate;
